import Vue from "vue";
import Vuex from "vuex";
import moment from 'moment';
moment.locale('es');

//arrow keys
Vue.config.keyCodes = {
    "arrow-keys": [37, 38, 39, 40]
};

Vue.use(require('vue-cookies'));
Vue.use(Vuex);

import Navbar from '../../../global/js/vue_modules/NavBar.vue'

import vueStore from './store.js';

const store = new Vuex.Store(vueStore);

if (document.getElementById('navbar')) {
    //console.log('navbar is loading...');
    new Vue({
        el: "#navbar",
        store,
        render(h) {
            return h(Navbar);
        }
    });
}

/**
 * 
 * code goes here
 */

import generator from './generator.vue';

if (document.getElementById('container-voucher')) {
    new Vue({
        el: "#container-voucher",
        render(h) {
            return h(generator);
        }
    });
}


/**
 * 
 * code goes here
 */